<template>
  <v-main class="dashboard-main">
    <v-container fluid class="pa-6">
      <!-- Dashboard Header -->
      <div class="dashboard-header mb-6">
        <h1 class="dashboard-title">Admin Dashboard</h1>
        <p class="dashboard-subtitle">Welcome back! Here's what's happening with Mehfil today.</p>
      </div>

      <!-- Statistics Cards Row -->
      <v-row class="mb-6">
        <v-col cols="12" sm="6" md="3" v-for="(stat, index) in statisticsCards" :key="index">
          <v-card class="stats-card" elevation="2" :color="stat.color" dark>
            <v-card-text class="pa-4">
              <div class="stats-content">
                <v-icon size="40" class="stats-icon mb-2">{{ stat.icon }}</v-icon>
                <h3 class="stats-number">{{ stat.value }}</h3>
                <p class="stats-label">{{ stat.label }}</p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Quick Actions Row -->
      <v-row class="mb-6">
        <v-col cols="12">
          <v-card elevation="2" class="quick-actions-card">
            <v-card-title class="pa-4">
              <h3>Quick Actions</h3>
            </v-card-title>
            <v-card-text class="pa-4">
              <v-row>
                <v-col cols="6" md="2" v-for="(action, index) in quickActions" :key="index">
                  <v-btn
                    class="quick-action-btn"
                    :color="action.color"
                    block
                    large
                    :to="action.route"
                    elevation="1"
                  >
                    <v-icon left>{{ action.icon }}</v-icon>
                    {{ action.label }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      statisticsCards: [
        {
          icon: 'mdi-account-group',
          value: '0',
          label: 'Total Users',
          color: 'primary'
        },
        {
          icon: 'mdi-microphone',
          value: '0',
          label: 'Active Rooms',
          color: 'success'
        },
        {
          icon: 'mdi-currency-usd-circle',
          value: '$0',
          label: 'Revenue',
          color: 'warning'
        },
        {
          icon: 'mdi-gift-outline',
          value: '0',
          label: 'Gifts Sent',
          color: 'error'
        }
      ],
      quickActions: [
        {
          icon: 'mdi-account-plus',
          label: 'Add User',
          color: 'primary',
          route: '/users/create'
        },
        {
          icon: 'mdi-microphone',
          label: 'Create Room',
          color: 'success',
          route: '/rooms/create'
        },
        {
          icon: 'mdi-gift',
          label: 'Manage Gifts',
          color: 'purple',
          route: '/gifts'
        },
        {
          icon: 'mdi-currency-usd',
          label: 'Recharge Coins',
          color: 'warning',
          route: '/recharge-coins'
        },
        {
          icon: 'mdi-shield-account',
          label: 'BD Members',
          color: 'info',
          route: '/bd-members'
        },
        {
          icon: 'mdi-cog',
          label: 'Settings',
          color: 'grey darken-1',
          route: '/settings'
        }
      ]
    };
  }
};
</script>

<style scoped>
.dashboard-main {
  background: #f5f5f5;
  min-height: 100vh;
}

.dashboard-header {
  text-align: center;
  margin-bottom: 32px;
}

.dashboard-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.dashboard-subtitle {
  font-size: 1.1rem;
  color: #6c757d;
  margin: 0;
}

.stats-card {
  border-radius: 16px !important;
  transition: all 0.3s ease;
}

.stats-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
}

.stats-content {
  text-align: center;
}

.stats-number {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 8px 0 4px 0;
  color: white;
}

.stats-label {
  font-size: 0.9rem;
  font-weight: 500;
  margin: 0;
  color: rgba(255,255,255,0.9);
}

.quick-actions-card {
  border-radius: 16px !important;
}

.quick-action-btn {
  border-radius: 12px !important;
  font-weight: 500;
  text-transform: none;
  height: 48px;
  margin-bottom: 12px;
}

.quick-action-btn:hover {
  transform: translateY(-2px);
}
</style>
